import { Context } from "states/Store";
import { useContext } from "react";
import { INFO, SUCCESS, WARNING, ERROR } from "services/common/Constants";


export function useAlert() {
    const  [,dispatch] = useContext(Context);
    function onError(msg) {
        dispatch({ type: "ALERT", alert: { type: ERROR, msg: msg } });
    }

    function onWarning(msg) {
        dispatch({ type: "ALERT", alert: { type: WARNING, msg: msg } });
    }

    function onSuccess(msg) {
        dispatch({ type: "ALERT", alert: { type: SUCCESS, msg: msg } });
    }

    function onInfo(msg) {
        dispatch({ type: "ALERT", alert: { type: INFO, msg: msg } });
    }

    return { onError, onWarning, onSuccess, onInfo }
}

